import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/theme.css';
import './styles/_variables.css';
import './styles/global-fixes.css';
// import './i18n';
import App from './App';
import { I18nextProvider } from 'react-i18next';
import i18n from "i18next";

createRoot(document.getElementById('root')!).render(
 
     <I18nextProvider i18n={i18n}>
     <App />
     </I18nextProvider>
 
  
)